import { useNavigate } from "react-router-dom";
import { ArrowLeft, SignOut, UserCircle } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";
import { LogoMark } from "@/components/Logo";
import MobileBottomNav from "@/mobile/MobileBottomNav";

/**
 * Layout del modo móvil. Top-bar fija (44px de alto), título centrado,
 * fondo blanco con borde inferior. El usuario puede volver atrás o salir.
 *
 * Pone una barra inferior con 3 tabs (Agenda · Expedientes · Mi control)
 * cuando NO hay `backTo` (vistas raíz). En detalles, se oculta.
 */
export default function MobileShell({ title, backTo, right = null, children,
                                       showBottomNav }) {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  // Por defecto: si NO hay backTo es una vista raíz → mostramos bottom-nav.
  const showNav = showBottomNav !== undefined ? showBottomNav : !backTo;

  return (
    <div className="min-h-screen bg-[#F7F8FA] text-foreground" data-testid="mobile-shell">
      <header
        className="sticky top-0 z-20 h-12 bg-white border-b border-[#E8EAED] flex items-center px-2 gap-1"
        data-testid="mobile-topbar"
      >
        {backTo ? (
          <button
            onClick={() => (typeof backTo === "string" ? navigate(backTo) : navigate(-1))}
            className="p-2 -ml-1 rounded-md hover:bg-zinc-100 active:bg-zinc-200"
            data-testid="mobile-back-btn"
            aria-label="Atrás"
          >
            <ArrowLeft className="w-5 h-5" weight="bold" />
          </button>
        ) : (
          <div className="px-2">
            <LogoMark className="h-6 w-6" />
          </div>
        )}

        <h1 className="flex-1 text-[15px] font-semibold tracking-tight truncate text-center" data-testid="mobile-title">
          {title}
        </h1>

        <div className="flex items-center gap-1">
          {right}
          {!backTo && (
            <>
              <button
                onClick={() => navigate("/mi-perfil")}
                className="p-2 rounded-md hover:bg-zinc-100"
                aria-label="Mi perfil"
                data-testid="mobile-profile-btn"
              >
                <UserCircle className="w-5 h-5" weight="duotone" />
              </button>
              <button
                onClick={logout}
                className="p-2 rounded-md hover:bg-zinc-100"
                aria-label="Salir"
                data-testid="mobile-logout-btn"
              >
                <SignOut className="w-5 h-5" weight="bold" />
              </button>
            </>
          )}
        </div>
      </header>

      <main className={showNav ? "pb-24" : "pb-6"} data-user={user?.id || ""}>
        {children}
      </main>

      {showNav && <MobileBottomNav />}
    </div>
  );
}
